// @flow

import React from "react";
import { useSelector } from "react-redux";

import { getOperacaoArquivos } from "../../state";

import AbrirArquivo from "./abrir-arquivo";
import SalvarArquivo from "./salvar-arquivo";
import CompartilharRelatorio from "./compartilhar-relatorio";

export { default as TemplatesModal } from "./templates-modal";

export const PaginaArquivos = () => {
  const operacao = useSelector(getOperacaoArquivos);

  switch (operacao) {
    case "ABRIR":
      return <AbrirArquivo />;

    case "SALVAR":
      return <SalvarArquivo />;

    case "COMPARTILHAR":
      return <CompartilharRelatorio />;

    default:
      return null;
  }
};
